'use client';

import { useEffect } from 'react';
import { isNativeApp } from '@/lib/native-app';

/**
 * ПРИЗНАК «СПРАВКУ ОТКРЫЛИ ИЗ ПРИЛОЖЕНИЯ» на <html> (data-help-app="1"). По нему
 * прячутся статьи и куски про подписку и заработок — в приложении покупок нет вовсе
 * (запрет №7 позиционирования).
 *
 * До первой отрисовки признак ставит короткий скрипт страницы (helpAppInitScript в
 * help-shell.tsx) — по `?app=1`, который приписывает кабинет, когда знает, что он в
 * приложении. Этот компонент только ДЕРЖИТ признак: клиентские пересборки <html>
 * (смена языка) стирают атрибуты, поставленные скриптом, — тот же случай, что лечит
 * AppearanceSync у темы. Новых методов моста тут нет и не нужно (запрет №8): признак
 * приложения — обычный isNativeApp() по подписи браузера.
 */
export function HelpAppMode() {
  useEffect(() => {
    const d = document.documentElement;
    const app =
      isNativeApp() || new URLSearchParams(window.location.search).get('app') === '1';
    if (!app) return;
    const set = () => {
      if (d.getAttribute('data-help-app') !== '1') d.setAttribute('data-help-app', '1');
    };
    set();
    const mo = new MutationObserver(set);
    mo.observe(d, { attributes: true, attributeFilter: ['data-help-app'] });
    return () => mo.disconnect();
  }, []);
  return null;
}
